import { render, staticRenderFns } from "./chemDetail.vue?vue&type=template&id=1d791d71"
import script from "./chemDetail.vue?vue&type=script&lang=js"
export * from "./chemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d791d71')) {
      api.createRecord('1d791d71', component.options)
    } else {
      api.reload('1d791d71', component.options)
    }
    module.hot.accept("./chemDetail.vue?vue&type=template&id=1d791d71", function () {
      api.rerender('1d791d71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemDetail.vue"
export default component.exports